module.exports = __webpack_public_path__ + "img/536246214a10a7031a92791afb5bf1ae.svg";